import Vue from 'vue'
import * as TYPES from './types'

export default {
  [TYPES.SET_LESSON_STEP_PROGRESS](state, { lessonStepId, lessonId }) {
    Vue.set(state.lessonStepProgress.byId, lessonStepId, lessonId)
  },
  [TYPES.SET_THEMES](state, { allIds, byId }) {
    Vue.set(state.theme, 'byId', byId)
    Vue.set(state.theme, 'allIds', allIds)
  },
  [TYPES.SET_LESSONS](state, { allIds, byId }) {
    Vue.set(state.lesson, 'byId', byId)
    Vue.set(state.lesson, 'allIds', allIds)
  },
  [TYPES.SET_LESSON_STEPS](state, { allIds, byId }) {
    Vue.set(state.lessonStep, 'byId', byId)
    Vue.set(state.lessonStep, 'allIds', allIds)
  },
  [TYPES.SET_FIREBASE_ID](state, firebaseId) {
    Vue.set(state, 'firebaseId', firebaseId)
  },
  [TYPES.RESET_FIREBASE_ID](state) {
    Vue.delete(state, 'firebaseId')
  },
  [TYPES.SET_THEME_FUNNELS](state, payload) {
    Object.keys(payload).forEach(themeId => {
      Vue.set(state.funnels, themeId, payload[themeId])
    })
  },
}
